import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import { Observable } from 'rxjs';
import { CampaignModel } from '../../models/campaigns/campaign.model';
import { ResponseModel } from '../../models/response/response';
import { FordProtect } from '../../models/vehicle/ford-protect.model';
import { API, environment } from '@core/envs';
import { SessionService } from '@agenda-customer-ui/data-access';
import { StorageKeys } from '@core/enums';

@Injectable()
export class VehicleService {
  constructor(private http: HttpClient, private sessionService: SessionService) {}

  getFordProtect(vin: string): Observable<ResponseModel<FordProtect>> {
    const url = `${environment.getRoute(API.owners)}/vehicles/v2/ford-protect`;
    const headers = new HttpHeaders({country: this.sessionService.getItem(StorageKeys.COUNTRY) });
    const param = { vin };
    return this.http.post<ResponseModel<FordProtect>>(url,  param, { headers });
  }

  findAllCampaignByParticipant(
    dateSchedule: string,
    fordprotectPlanType: string,
    revision: number,
    scheduleOrigin: string,
    vehicleModelGroup: number,
    modelYear: number,
    revisionPrice: number
  ): Observable<ResponseModel<CampaignModel[]>> {
    const api = environment.getRoute(API.backoffice);
    const vin = this.sessionService.getItem(StorageKeys.VIN_ACTIVE_DASHBOARD);
    const url = `${api}/campaigns`;
    const headers = new HttpHeaders({
      country: this.sessionService.getItem(StorageKeys.COUNTRY),
      'content-type': 'application/json',
    });
    const body = {
      vin,
      vehicleModelGroup: String(vehicleModelGroup),
      vehicleModelYear: String(modelYear),
      dateSchedule: dayjs(dateSchedule).format('YYYY-MM-DD'),
      revision: String(revision),
      protectPlanType: fordprotectPlanType,
      scheduleOrigin,
      revisionPrice: String(revisionPrice),
    };

    return this.http.post<ResponseModel<CampaignModel[]>>(url, body, { headers });
  }
}
